module.exports = __webpack_public_path__ + "static/media/s_6.b5af7dc9.mp3";